const serviceIntroductionRoutes = [
    {
        path:'index',
        name:'serviceIntroduction-index',
        component: () => import(/* webpackChunkName: "about" */ '@/views/serviceIntroduction/index.vue')
    },
    {
        path:'buy',
        name:'serviceIntroduction-buy',
        component: () => import(/* webpackChunkName: "about" */ '@/views/serviceIntroduction/buy.vue')
    },
    {
        path:'introduce',
        name:'serviceIntroduction-introduce',
        component: () => import(/* webpackChunkName: "about" */ '@/views/serviceIntroduction/introduce.vue')
    }
    
  ]
  export default serviceIntroductionRoutes